<template>
  <v-app>
    <Navbar />
    <v-content>
      <router-view />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
export default {
  name: "App",
  components: {
    Navbar,
    Footer
  }
};
</script>

<style>
.header-gradient {
  background: url("~@/assets/head_bg.jpeg") no-repeat center center;
  background-size: cover;
}
.header-gradient-old {
  background: url("https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg")
    no-repeat center center;
  background-size: cover;
}
.footer-gradient {
  background: linear-gradient(to right, #f59423, #e2632a, #ca2136, #832778);
}
</style>
